const initialState = {
  subMenuOpen: Boolean(false),
  subMenuItems: [],
  };

export default (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_SUB_MENU':
      return {
        subMenuOpen: false,
        subMenuItems: [],
      };
    case 'SUB_MENU_STATE':
      return {
        ...state,
        subMenuOpen: action.payload,
      };
    case 'SUB_MENU_ITEMS':
      return {
        ...state,
        subMenuItems: action.payload
      };
    case 'SUB_MENU_PATH_ACTIVE':
      return {
        ...state,
        subMenuPathActive: action.payload
      };
    case 'NORMAL_MENU_PATH_ACTIVE':
      return {
        ...state,
        menuPathActive: action.payload
      };
    default:
      return state;
  }
};
